function hasOwn(payload, key) {
  return Object.prototype.hasOwnProperty.call(payload, key);
}

export function normalizedPhotoIdStatusFromUser(user) {
  if (!user) return "not_required";
  if (user.photo_id_verification_status) {
    return user.photo_id_verification_status;
  }
  if (user.kyc_check === true) return "verified";
  const uploaded = (
    user.photo_id_uploaded === true ||
    Boolean(user.kyc_document_url) ||
    Boolean(user.url)
  );
  if (user.photo_id_required === true && uploaded) {
    return "replacement_required";
  }
  if (user.photo_id_required === true) return "required";
  if (uploaded) return "pending_review";
  return "not_required";
}

export function photoIdStatePatchFromPayload(payload = {}) {
  const patch = {};
  if (hasOwn(payload, "photo_id_uploaded")) {
    patch.photo_id_uploaded = payload.photo_id_uploaded;
  } else if (payload.url || payload.kyc_document_url) {
    patch.photo_id_uploaded = true;
  }

  if (hasOwn(payload, "photo_id_verification_status")) {
    patch.photo_id_verification_status = payload.photo_id_verification_status;
  } else if (patch.photo_id_uploaded === true && payload.kyc_check !== true) {
    patch.photo_id_verification_status = "pending_review";
  }

  if (hasOwn(payload, "photo_id_required")) {
    patch.photo_id_required = payload.photo_id_required;
  } else if (
    patch.photo_id_verification_status === "pending_review" ||
    patch.photo_id_verification_status === "verified"
  ) {
    patch.photo_id_required = false;
  }

  return patch;
}
